<template>
    <div class="make-your-team">
        <div class="container-fluid">
            <!-- Заголовок страницы -->
            <div class="row mb-4">
                <div class="col-12">
                    <div class="page-header">
                        <h1 class="page-title">
                            <i class="fas fa-rocket mr-2 d-none d-md-block" style="font-size: 1.2em;"></i>
                            Создай свою команду
                        </h1>
                        <p class="page-subtitle">
                            Добавляй себе в команду новых агентов и получай с них процент с продаж + 3000 рублей за подключение нового агента в команду с выплатой после первой закрытой сделки вашего агента.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Информационные карточки -->
            <div class="row mb-4">
                <div class="col-md-4 mb-3">
                    <div class="info-card">
                        <div class="info-card-icon">
                            <i class="fas fa-chart-line"></i>
                        </div>
                        <div class="info-card-content">
                            <h5>Процент с продаж</h5>
                            <p>Получай процент с каждой сделки, которую заключают агенты в твоей команде</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 mb-3">
                    <div class="info-card">
                        <div class="info-card-icon">
                            <i class="fas fa-gem"></i>
                        </div>
                        <div class="info-card-content">
                            <h5>3000 за подключение</h5>
                            <p>Бонус 3000 рублей за каждого нового агента, подключенного в твою команду</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 mb-3">
                    <div class="info-card">
                        <div class="info-card-icon">
                            <i class="fas fa-trophy"></i>
                        </div>
                        <div class="info-card-content">
                            <h5>Выплата после сделки</h5>
                            <p>Бонус выплачивается после первой закрытой сделки нового агента</p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Статистика команды -->
            <div class="row mb-4" v-if="teamStats" style="display: none;">
                <div class="col-12">
                    <div class="stats-card">
                        <h4 class="stats-title">Статистика твоей команды</h4>
                        <div class="row">
                            <div class="col-md-3 col-sm-6 mb-3">
                                <div class="stat-item">
                                    <div class="stat-number">{{ teamStats.total_requests }}</div>
                                    <div class="stat-label">Всего заявок</div>
                                </div>
                            </div>
                                                         <div class="col-md-3 col-sm-6 mb-3">
                                 <div class="stat-item">
                                     <div class="stat-number stat-pending">{{ teamStats.pending_requests }}</div>
                                     <div class="stat-label">Ожидают рассмотрения</div>
                                 </div>
                             </div>
                             <div class="col-md-3 col-sm-6 mb-3">
                                 <div class="stat-item">
                                     <div class="stat-number stat-approved">{{ teamStats.approved_requests }}</div>
                                     <div class="stat-label">Одобрено</div>
                                 </div>
                             </div>
                             <div class="col-md-3 col-sm-6 mb-3">
                                 <div class="stat-item">
                                     <div class="stat-number stat-rejected">{{ teamStats.rejected_requests }}</div>
                                     <div class="stat-label">Отклонено</div>
                                 </div>
                             </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Форма подключения нового агента -->
            <div class="row">
                <div class="col-lg-8 mx-auto">
                    <div class="form-card">
                        <h4 class="form-title">
                            <i class="fas fa-user-astronaut mr-2"></i>
                            Подключить нового агента
                        </h4>
                        
                        <form @submit.prevent="submitForm" class="team-form">
                            <div class="row">
                                <div class="col-md-12 mb-3">
                                    <label for="new_agent_name" class="form-label">ФИО нового агента *</label>
                                    <input
                                        type="text"
                                        id="new_agent_name"
                                        v-model="form.new_agent_name"
                                        class="form-control"
                                        :class="{ 'is-invalid': errors.new_agent_name }"
                                        placeholder="Введите полное имя нового агента"
                                        required
                                    />
                                    <div v-if="errors.new_agent_name" class="invalid-feedback">
                                        {{ errors.new_agent_name[0] }}
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6 mb-3">
                                    <label for="new_agent_email" class="form-label">Email *</label>
                                    <input
                                        type="email"
                                        id="new_agent_email"
                                        v-model="form.new_agent_email"
                                        class="form-control"
                                        :class="{ 'is-invalid': errors.new_agent_email }"
                                        placeholder="example@email.com"
                                        required
                                    />
                                    <div v-if="errors.new_agent_email" class="invalid-feedback">
                                        {{ errors.new_agent_email[0] }}
                                    </div>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label for="new_agent_phone" class="form-label">Телефон *</label>
                                    <input
                                        type="tel"
                                        id="new_agent_phone"
                                        v-model="form.new_agent_phone"
                                        class="form-control"
                                        :class="{ 'is-invalid': errors.new_agent_phone }"
                                        placeholder="+7XXXXXXXXXX"
                                        required
                                    />
                                    <div v-if="errors.new_agent_phone" class="invalid-feedback">
                                        {{ errors.new_agent_phone[0] }}
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 mb-3">
                                    <label for="notes" class="form-label">Дополнительные заметки</label>
                                    <textarea
                                        id="notes"
                                        v-model="form.notes"
                                        class="form-control"
                                        rows="3"
                                        placeholder="Дополнительная информация о новом агенте (необязательно)"
                                    ></textarea>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <button
                                        type="submit"
                                        class="btn btn-primary btn-lg btn-block"
                                        :disabled="loading"
                                        style="height: 60px;"
                                    >
                                        <i v-if="loading" class="fas fa-spinner fa-spin mr-2"></i>
                                        <i v-else class="fas fa-magic mr-2"></i>
                                        {{ loading ? 'Подключение...' : 'Подключить!' }}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <!-- Уведомление о расширенном функционале -->
            <div class="row mt-4">
                <div class="col-12">
                    <div class="alert alert-info">
                        <i class="fas fa-lightbulb mr-2"></i>
                        <strong>Расширенный функционал по работе с командой в разработке</strong>
                        <br>
                        В ближайшее время будет доступен расширенный функционал для управления командой, включая аналитику, мотивацию и детальную статистику по каждому вашему агенту.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { API_AGENT_TEAM_REQUESTS } from '@/constants/api';

export default {
    name: 'MakeYourTeam',
    data() {
        return {
            loading: false,
            teamStats: null,
            form: {
                new_agent_name: '',
                new_agent_email: '',
                new_agent_phone: '',
                notes: ''
            },
            errors: {}
        };
    },
    computed: {
        ...mapGetters('auth', ['currentUser'])
    },
    mounted() {
        this.loadTeamStats();
    },
    methods: {
        async loadTeamStats() {
            try {
                const response = await api.call('get', `${API_AGENT_TEAM_REQUESTS}/stats`);
                if (response.data.success) {
                    this.teamStats = response.data.data;
                }
            } catch (error) {
                console.error('Ошибка загрузки статистики команды:', error);
            }
        },
        async submitForm() {
            this.loading = true;
            this.errors = {};

            try {
                const response = await api.call('post', API_AGENT_TEAM_REQUESTS, this.form);
                
                if (response.data.success) {
                    // Показываем уведомление об успехе
                    this.$toast('Новый агент успешно подключен к вашей команде!', {
                        type: 'success',
                        position: 'top-right',
                        timeout: 5000
                    });

                    // Очищаем форму
                    this.form = {
                        new_agent_name: '',
                        new_agent_email: '',
                        new_agent_phone: '',
                        notes: ''
                    };

                    // Обновляем статистику
                    this.loadTeamStats();
                }
            } catch (error) {
                if (error.response && error.response.data.errors) {
                    this.errors = error.response.data.errors;
                } else {
                    this.$toast('Произошла ошибка при подключении агента', {
                        type: 'error',
                        position: 'top-right',
                        timeout: 5000
                    });
                }
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>

<style scoped>
.make-your-team {
    padding: 20px 0;
}

.page-header {
    text-align: center;
    margin-bottom: 30px;
}

.page-title {
    color: #2c3e50;
    font-weight: 700;
    margin-bottom: 10px;
    position: relative;
}

.page-title i {
    background: linear-gradient(135deg, #0d6348 0%, #e37926 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    animation: rocketFloat 3s ease-in-out infinite;
}

@media (max-width: 768px) {
    .page-title {
        font-size: 1.5rem;
    }
}

@keyframes rocketFloat {
    0%, 100% { transform: translateY(0px) rotate(0deg); }
    50% { transform: translateY(-10px) rotate(5deg); }
}

.page-subtitle {
    color: #7f8c8d;
    font-size: 1.1rem;
    line-height: 1.6;
}

.info-card {
    background: #fff;
    border-radius: 10px;
    padding: 25px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
    height: 100%;
    transition: transform 0.3s ease;
}

.info-card:hover {
    transform: translateY(-5px);
}

.info-card-icon {
    font-size: 3rem;
    margin-bottom: 20px;
    text-align: center;
    position: relative;
}

.info-card-icon i {
    background: linear-gradient(135deg, #0d6348 0%, #e37926 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    filter: drop-shadow(0 4px 8px rgba(0,0,0,0.1));
    transition: all 0.3s ease;
}

.info-card:hover .info-card-icon i {
    transform: scale(1.1) rotate(5deg);
    filter: drop-shadow(0 6px 12px rgba(0,0,0,0.2));
}

/* Специальные стили для каждой иконки */
.info-card:nth-child(1) .info-card-icon i {
    background: linear-gradient(135deg, #0d6348 0%, #1a8a5f 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.info-card:nth-child(2) .info-card-icon i {
    background: linear-gradient(135deg, #e37926 0%, #f7931e 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.info-card:nth-child(3) .info-card-icon i {
    background: linear-gradient(135deg, #0d6348 0%, #e37926 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.info-card-content h5 {
    color: #2c3e50;
    font-weight: 600;
    margin-bottom: 10px;
    text-align: center;
}

.info-card-content p {
    color: #7f8c8d;
    text-align: center;
    margin: 0;
}

.stats-card {
    background: #fff;
    border-radius: 10px;
    padding: 25px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.stats-title {
    color: #2c3e50;
    font-weight: 600;
    margin-bottom: 20px;
    text-align: center;
}

.stat-item {
    text-align: center;
    padding: 15px;
}

.stat-number {
    font-size: 2.5rem;
    font-weight: 800;
    background: linear-gradient(135deg, #0d6348 0%, #e37926 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    margin-bottom: 5px;
    animation: countUp 2s ease-out;
}

@keyframes countUp {
    from { 
        opacity: 0; 
        transform: translateY(20px); 
    }
    to { 
        opacity: 1; 
        transform: translateY(0); 
    }
}

/* Стили для статистики с корпоративными цветами */
.stat-pending {
    background: linear-gradient(135deg, #e37926 0%, #f7931e 100%) !important;
    -webkit-background-clip: text !important;
    -webkit-text-fill-color: transparent !important;
}

.stat-approved {
    background: linear-gradient(135deg, #0d6348 0%, #1a8a5f 100%) !important;
    -webkit-background-clip: text !important;
    -webkit-text-fill-color: transparent !important;
}

.stat-rejected {
    background: linear-gradient(135deg, #dc3545 0%, #c82333 100%) !important;
    -webkit-background-clip: text !important;
    -webkit-text-fill-color: transparent !important;
}

.stat-label {
    color: #7f8c8d;
    font-size: 0.9rem;
}

.form-card {
    background: #fff;
    border-radius: 10px;
    padding: 30px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.form-title {
    color: #2c3e50;
    font-weight: 600;
    margin-bottom: 25px;
    text-align: center;
}

.team-form {
    max-width: 600px;
    margin: 0 auto;
}

.form-label {
    font-weight: 600;
    color: #2c3e50;
    margin-bottom: 8px;
}

.form-control {
    border: 2px solid #e9ecef;
    border-radius: 8px;
    padding: 12px 15px;
    font-size: 1rem;
    transition: border-color 0.3s ease;
}

.form-control:focus {
    border-color: #0d6348;
    box-shadow: 0 0 0 0.2rem rgba(13,99,72,0.25);
}

.btn-primary {
    background: linear-gradient(135deg, #0d6348 0%, #e37926 100%);
    border: none;
    border-radius: 12px;
    padding: 15px 30px;
    font-weight: 600;
    font-size: 1.1rem;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
}

.btn-primary::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
    transition: left 0.5s;
}

.btn-primary:hover::before {
    left: 100%;
}

.btn-primary:hover {
    transform: translateY(-3px) scale(1.02);
    box-shadow: 0 8px 25px rgba(13,99,72,0.4);
}

.btn-primary:disabled {
    transform: none;
    box-shadow: none;
}

.alert {
    border-radius: 10px;
    border: none;
    padding: 20px;
}

.alert-info {
    background: linear-gradient(135deg, #e8f5e8 0%, #d4edda 100%);
    color: #0d6348;
    border-left: 4px solid #e37926;
}

@media (max-width: 768px) {
    .make-your-team {
        padding: 10px 0;
    }
    
    .form-card {
        padding: 20px;
    }
    
    .info-card {
        padding: 20px;
    }
    
    .stats-card {
        padding: 20px;
    }
}
</style>
